import Block from '../block'

export default class ReadMore extends Block {
	static title = 'read-more'

	init() {
		this.toggleButton = this.getElement('toggle')
		this.toggleContent = this.getElement('content')

		// height when overflow is hidden
		this.maxHeight = this.element.offsetHeight

		if (this.toggleContent.offsetHeight < this.element.offsetHeight) {
			this.element.style.maxHeight = this.toggleContent.offsetHeight
			this.addModifier('active')
		}

		if (this.toggleButton) {
			this.toggleButton.addEventListener('click', () => this.toggleOverflow())
		}
	}

	toggleOverflow() {
		this.toggleModifier('active')

		if (!this.hasModifier('active')) {
			this.element.style.maxHeight = `${this.maxHeight}px`
			return
		}

		this.element.style.maxHeight = `${this.toggleContent.offsetHeight}px`
	}
}
